export { DMS_MODULE } from '@/modules/ciselnik/constants';
export const CRUMB_LABEL_KEY = 'edtFaktProfilLakSzbNahr';
export const NAME = <const>'NahradniSazbaLakovaci';
